import React from 'react';

// Filet de sécurité : sans ça, la moindre erreur de rendu React démonte
// TOUTE l'app et laisse l'utilisateur devant un écran blanc, sans recours
// sauf recharger manuellement. Ici on affiche un écran de secours clair,
// avec un bouton pour recharger, et on log l'erreur pour le diagnostic.
export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    console.error('PlanifPro — erreur applicative interceptée:', error, info?.componentStack);
  }

  render() {
    if (!this.state.hasError) return this.props.children;
    return (
      <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#f8fafc', padding: '24px', fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif' }}>
        <div style={{ maxWidth: '440px', textAlign: 'center', background: '#fff', borderRadius: '20px', padding: '40px 32px', boxShadow: '0 10px 40px rgba(0,0,0,0.08)', border: '1px solid #f0f0f0' }}>
          <div style={{ fontSize: '48px', marginBottom: '12px' }}>😕</div>
          <h2 style={{ fontSize: '22px', fontWeight: 800, margin: '0 0 10px', color: '#0a0a0a' }}>Un problème est survenu</h2>
          <p style={{ fontSize: '15px', color: '#6b7280', lineHeight: 1.5, margin: '0 0 24px' }}>
            Une erreur inattendue a interrompu l'affichage. Vos données ne sont pas perdues — rechargez la page pour continuer.
          </p>
          <button
            onClick={() => window.location.reload()}
            style={{ padding: '13px 28px', background: '#0369a1', color: '#fff', border: 'none', borderRadius: '980px', cursor: 'pointer', fontWeight: 700, fontSize: '15px' }}
          >
            Recharger la page
          </button>
        </div>
      </div>
    );
  }
}
